import { render, staticRenderFns } from "./emailEditor.vue?vue&type=template&id=97efd1cc&scoped=true"
import script from "./emailEditor.vue?vue&type=script&lang=js"
export * from "./emailEditor.vue?vue&type=script&lang=js"
import style0 from "./emailEditor.vue?vue&type=style&index=0&id=97efd1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97efd1cc",
  null
  
)

export default component.exports